// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../utils/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-style-ctrl {
  position: relative;
  overflow: visible !important;
}
.map-style-btn {
  background: transparent !important;
  border: none !important;
  width: 36px !important;
  height: 36px !important;
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  transition: background 0.18s !important;
}
.map-style-btn svg,
.map-style-btn img,
.map-style-btn .mapboxgl-ctrl-icon {
  filter: var(--map-icon-filter);
  transition: filter 0.2s ease;
}

.map-style-btn:hover svg,
.map-style-btn:hover img,
.map-style-btn:hover .mapboxgl-ctrl-icon {
  filter: var(--map-icon-filter-hover);
}

.map-style-btn:hover {
  background: var(--map-ctrl-hover) !important;
}

.map-style-btn:active {
  background: var(--map-ctrl-active) !important;
}
.map-style-panel {
  position: absolute;
  right: 44px;
  top: 0;
  background: var(--map-panel-bg);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid var(--map-panel-border);
  border-radius: 12px;
  padding: 10px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 7px;
  min-width: 214px;
  opacity: 0;
  pointer-events: none;
  transform: translateX(6px);
  transition: opacity 0.18s, transform 0.18s;
}

.map-style-panel.open {
  opacity: 1;
  pointer-events: all;
  transform: translateX(0);
}
.map-style-tile {
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  transition: border-color 0.15s, transform 0.12s;
  display: flex;
  flex-direction: column;
}

.map-style-tile:hover {
  transform: scale(1.04);
  border-color: var(--map-border-focus);
}

.map-style-tile.active {
  border-color: var(--map-panel-tile-active); 
}

.map-style-thumb {
  width: 100%;
  height: 48px;
}

.map-style-thumb--dark       { background: #172631; }
.map-style-thumb--light      { background: #e8e4d8; }
.map-style-thumb--streets    { background: #d4c9a8; }
.map-style-thumb--satellite  { background: #2d4a2d; }
.map-style-thumb--outdoors   { background: #c8d8b8; }
.map-style-thumb--navigation { background: #1a2a3a; }

.map-style-label {
  font-size: 10.5px;
  color: var(--map-panel-label);
  text-align: center;
  padding: 4px 2px;
  background: var(--map-panel-label-bg);
  letter-spacing: 0.2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.map-style-tile.active .map-style-label {
  color: var(--map-panel-label-active);
}`, "",{"version":3,"sources":["webpack://./src/components/molecules/mapStyleSwitcher/MapStyleSwitcher.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,uCAAuC;AACzC;AACA;;;EAGE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,6CAA6C;AAC/C;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,+BAA+B;EAC/B,2BAA2B;EAC3B,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,+CAA+C;EAC/C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,+BAA+B,mBAAmB,EAAE;AACpD,+BAA+B,mBAAmB,EAAE;AACpD,+BAA+B,mBAAmB,EAAE;AACpD,+BAA+B,mBAAmB,EAAE;AACpD,+BAA+B,mBAAmB,EAAE;AACpD,+BAA+B,mBAAmB,EAAE;;AAEpD;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":["@import '../../../utils/colors.css';\n\n.map-style-ctrl {\n  position: relative;\n  overflow: visible !important;\n}\n.map-style-btn {\n  background: transparent !important;\n  border: none !important;\n  width: 36px !important;\n  height: 36px !important;\n  cursor: pointer !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  transition: background 0.18s !important;\n}\n.map-style-btn svg,\n.map-style-btn img,\n.map-style-btn .mapboxgl-ctrl-icon {\n  filter: var(--map-icon-filter);\n  transition: filter 0.2s ease;\n}\n\n.map-style-btn:hover svg,\n.map-style-btn:hover img,\n.map-style-btn:hover .mapboxgl-ctrl-icon {\n  filter: var(--map-icon-filter-hover);\n}\n\n.map-style-btn:hover {\n  background: var(--map-ctrl-hover) !important;\n}\n\n.map-style-btn:active {\n  background: var(--map-ctrl-active) !important;\n}\n.map-style-panel {\n  position: absolute;\n  right: 44px;\n  top: 0;\n  background: var(--map-panel-bg);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  border: 1px solid var(--map-panel-border);\n  border-radius: 12px;\n  padding: 10px;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 7px;\n  min-width: 214px;\n  opacity: 0;\n  pointer-events: none;\n  transform: translateX(6px);\n  transition: opacity 0.18s, transform 0.18s;\n}\n\n.map-style-panel.open {\n  opacity: 1;\n  pointer-events: all;\n  transform: translateX(0);\n}\n.map-style-tile {\n  border-radius: 8px;\n  overflow: hidden;\n  cursor: pointer;\n  border: 2px solid transparent;\n  transition: border-color 0.15s, transform 0.12s;\n  display: flex;\n  flex-direction: column;\n}\n\n.map-style-tile:hover {\n  transform: scale(1.04);\n  border-color: var(--map-border-focus);\n}\n\n.map-style-tile.active {\n  border-color: var(--map-panel-tile-active); \n}\n\n.map-style-thumb {\n  width: 100%;\n  height: 48px;\n}\n\n.map-style-thumb--dark       { background: #172631; }\n.map-style-thumb--light      { background: #e8e4d8; }\n.map-style-thumb--streets    { background: #d4c9a8; }\n.map-style-thumb--satellite  { background: #2d4a2d; }\n.map-style-thumb--outdoors   { background: #c8d8b8; }\n.map-style-thumb--navigation { background: #1a2a3a; }\n\n.map-style-label {\n  font-size: 10.5px;\n  color: var(--map-panel-label);\n  text-align: center;\n  padding: 4px 2px;\n  background: var(--map-panel-label-bg);\n  letter-spacing: 0.2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.map-style-tile.active .map-style-label {\n  color: var(--map-panel-label-active);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
